import { render, staticRenderFns } from "./KG_Map.vue?vue&type=template&id=16af6c9a"
import script from "./KG_Map.vue?vue&type=script&lang=js"
export * from "./KG_Map.vue?vue&type=script&lang=js"
import style0 from "./KG_Map.vue?vue&type=style&index=0&id=16af6c9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports